/* Product-specific Judge.me widgets. The existing Shopify app embed owns loading. */
(() => {
  const root = document.querySelector('#modal-content');
  const productRoot = document.querySelector('#product-page');
  if (!root) return;
  const products = new Map((window.PS_CATALOG || []).map(p => [p.id, p]));
  let mountSequence = 0;
  // Native <dialog> makes body-level popups inert. Keep Judge.me's own form in
  // the open dialog, outside the replaceable product content.
  function attachReviewForm() {
    const dialog = root.closest('dialog[open]');
    if (!dialog || !root.querySelector('[data-product-reviews]')) return;
    document.querySelectorAll('body > .jdgm-review-widget-modal').forEach(form => dialog.append(form));
  }
  new MutationObserver(attachReviewForm).observe(document.body, {childList: true});
  root.closest('dialog')?.addEventListener('close', () => {
    document.querySelector('.jdgm-write-review-modal__close-btn')?.click();
  });
  function makeBadge(id) {
    const badge = document.createElement('div');
    badge.className = 'jdgm-widget jdgm-preview-badge';
    badge.dataset.id = id;
    badge.dataset.autoInstall = 'false';
    return badge;
  }
  function mountCards() {
    document.querySelectorAll('.catalog-product').forEach(card => {
      if (card.querySelector('.jdgm-preview-badge')) return;
      const product = products.get(card.querySelector('[data-catalog-product]')?.dataset.catalogProduct);
      const id = String(product?.shopifyId || '');
      if (/^\d+$/.test(id)) {
        const badge=makeBadge(id),slot=card.querySelector('.card-price-slot');
        if(slot)slot.after(badge);else card.querySelector('h3')?.after(badge);
      }
    });
  }
  function mountDetail(container) {
    const detail = container.querySelector('.catalog-detail[data-product-id]');
    if (!detail || detail.querySelector('[data-product-reviews]')) return;
    const product = products.get(detail.dataset.productId);
    const id = String(product?.shopifyId || '');
    if (!/^\d+$/.test(id)) return;
    const section = document.createElement('section');
    section.dataset.productReviews = id;
    section.style.cssText = 'grid-column:1/-1;position:relative;z-index:5;background:#fff;min-width:0;border-top:1px solid #e4e8df;margin-top:24px;padding-top:24px';
    section.setAttribute('aria-label', 'Customer product reviews');
    const widget = document.createElement('div');
    widget.id = 'judgeme_product_reviews';
    widget.className = 'jdgm-widget jdgm-review-widget';
    Object.assign(widget.dataset, {
      productTitle: product.name, id, productId: id, widget: 'review',
      autoInstall: 'false', shopReviews: 'false',
      entryPoint: 'review_widget.js', entryKey: 'review-widget/main.js'
    });
    section.append(widget);
    detail.append(section);
    attachReviewForm();
    const summary=detail.querySelector('#pdp-review-summary');
    if(summary)summary.prepend(makeBadge(id));else detail.querySelector('h1,h2')?.after(makeBadge(id));
    // Match the official app block: the review entry script is separate from loader.js.
    const loader = [...document.scripts].find(s =>
      /^https:\/\/cdn\.shopify\.com\/extensions\/.+\/assets\/loader\.js(?:\?|$)/.test(s.src));
    if (loader) {
      const entry = document.createElement('script');
      entry.type = 'module';
      const entryURL = new URL(loader.src.replace('/loader.js', '/review_widget.js'));
      entryURL.searchParams.set('ps_mount', String(++mountSequence));
      entry.src = entryURL.href;
      entry.async = true;
      entry.onload = () => entry.remove();
      entry.onerror = () => entry.remove();
      document.head.append(entry);
    }
  }
  function mount(){mountDetail(root);if(productRoot)mountDetail(productRoot);}
  new MutationObserver(mount).observe(root, { childList: true, subtree: true });
  if(productRoot)new MutationObserver(mount).observe(productRoot,{childList:true,subtree:true});
  ['home-products', 'catalog-products'].forEach(id => {
    const grid = document.getElementById(id);
    if (grid) new MutationObserver(mountCards).observe(grid, {childList: true});
  });
  mountCards();
  mount();
})();
